import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00fb81c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "information-header level flex-wrap" }
const _hoisted_2 = { class: "information-header-contents" }
const _hoisted_3 = { class: "information-header-heading level-left is-mobile" }
const _hoisted_4 = {
  class: "title",
  id: "information-header-title"
}
const _hoisted_5 = { class: "information-header-meta level-left is-hidden-mobile" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "：", -1))
const _hoisted_7 = {
  key: 0,
  class: "level-left"
}
const _hoisted_8 = { class: "has-text-modest" }
const _hoisted_9 = { id: "information-header-author" }
const _hoisted_10 = { class: "has-text-modest" }
const _hoisted_11 = { id: "information-header-publisher" }
const _hoisted_12 = { class: "has-text-modest" }
const _hoisted_13 = { id: "information-header-publicationDate" }
const _hoisted_14 = { class: "information-header-nav level is-hidden-mobile" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = {
  key: 1,
  class: "level"
}
const _hoisted_18 = {
  key: 2,
  class: "level"
}
const _hoisted_19 = {
  key: 3,
  class: "level"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BookMarkButton = _resolveComponent("BookMarkButton")!
  const _component_IconNdlOnline = _resolveComponent("IconNdlOnline")!
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_IconLoading = _resolveComponent("IconLoading")!
  const _component_PrintingModal = _resolveComponent("PrintingModal")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.itemTitle), 1)
        ]),
        (!_ctx.isKn && !_ctx.isRekion)
          ? (_openBlock(), _createBlock(_component_BookMarkButton, {
              key: 0,
              showFullScreenHeader: _ctx.showFullScreenHeader,
              hideFullScreenHeader: _ctx.hideFullScreenHeader,
              pid: _ctx.pid,
              isContentDetailPageHeader: true
            }, null, 8, ["showFullScreenHeader", "hideFullScreenHeader", "pid"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showFullScreenHeader && _ctx.showFullScreenHeader(...args))),
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideFullScreenHeader && _ctx.hideFullScreenHeader(...args))),
          href: "#item-detail-information",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.scrollToElementTop('#item-detail-information')), ["prevent"])),
          onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.scrollToElementTop('#item-detail-information')), ["prevent"]), ["space","enter"])),
          class: "has-text-link display-header-on-focus"
        }, _toDisplayString(_ctx.$t('informationHeader.bibliographicInformation')), 33),
        _hoisted_6,
        (_ctx.item.meta['0010Dtct'] || _ctx.item.meta['0020Dtct'] || _ctx.item.meta['0058Dod'])
          ? (_openBlock(), _createElementBlock("dl", _hoisted_7, [
              (_ctx.item.meta['0010Dtct'])
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("dt", _hoisted_8, _toDisplayString(_ctx.getMetadataLabelName('0010Dtct')), 1),
                    _createElementVNode("dd", _hoisted_9, _toDisplayString(_ctx.creatorArrayProcessing(_ctx.item.meta['0010Dtct'])), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.item.meta['0020Dtct'])
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("dt", _hoisted_10, _toDisplayString(_ctx.getMetadataLabelName('0020Dtct')), 1),
                    _createElementVNode("dd", _hoisted_11, _toDisplayString(_ctx.publisherArrayProcessing(_ctx.item.meta['0020Dtct'])), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.item.meta['0058Dod'])
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("dt", _hoisted_12, _toDisplayString(_ctx.getMetadataLabelName('0058Dod')), 1),
                    _createElementVNode("dd", _hoisted_13, _toDisplayString(_ctx.metaArrayProcessing(_ctx.item.meta['0058Dod'])), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_ctx.isKn)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            style: {"color":"#05a"},
            href: `${_ctx.KN_APPLICATION_LINK}/detail/${_ctx.item.pid}?lang=${_ctx.lang}`
          }, _toDisplayString(_ctx.$t('informationHeader.KnDetailInformationLabel')), 9, _hoisted_15))
        : _createCommentVNode("", true),
      (_ctx.viewerType !== 'NoContentViewer')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.bibId)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  id: "information-header-ndl-online-link",
                  href: `http://id.ndl.go.jp/bib/${_ctx.bibId}`,
                  rel: "noopener",
                  class: "level is-mobile"
                }, [
                  _createVNode(_component_IconNdlOnline),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('informationHeader.lookupNdlOnline')), 1)
                ], 8, _hoisted_16))
              : _createCommentVNode("", true),
            (_ctx.isAllowedPrint && _ctx.viewerType === 'TheImageViewer' && _ctx.canSimView)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                  _createVNode(_component_ButtonIcon, {
                    onClick: _ctx.openPrintModal,
                    onKeydown: _withKeys(_withModifiers(_ctx.openPrintModal, ["prevent"]), ["space","enter"]),
                    styled: "is-accent",
                    icon: "printer",
                    type: "button",
                    text: _ctx.$t('parts.print'),
                    disabled: _ctx.downloadingFlag,
                    class: "information-header-nav-print-guide",
                    id: "open-printing-modal"
                  }, null, 8, ["onClick", "onKeydown", "text", "disabled"]),
                  (_ctx.downloadingFlag)
                    ? (_openBlock(), _createBlock(_component_IconLoading, {
                        key: 0,
                        class: "download-icon-loading"
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAllowedPrintKss && _ctx.viewerType === 'TheImageViewer' && _ctx.canSimView)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                  _createVNode(_component_ButtonIcon, {
                    onFocus: _ctx.showFullScreenHeader,
                    onBlur: _ctx.hideFullScreenHeader,
                    onClick: _ctx.openPrintKssModal,
                    onKeydown: _withKeys(_withModifiers(_ctx.openPrintKssModal, ["prevent"]), ["space","enter"]),
                    styled: "is-accent",
                    icon: "printer",
                    type: "button",
                    text: _ctx.$t('parts.print'),
                    disabled: _ctx.downloadingFlag,
                    class: "information-header-nav-print-guide",
                    id: "open-kss-printing-modal"
                  }, null, 8, ["onFocus", "onBlur", "onClick", "onKeydown", "text", "disabled"]),
                  (_ctx.downloadingFlag)
                    ? (_openBlock(), _createBlock(_component_IconLoading, {
                        key: 0,
                        class: "download-icon-loading"
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAllowedPrintInternet && _ctx.viewerType === 'TheImageViewer' && _ctx.canSimView)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                  _createVNode(_component_ButtonIcon, {
                    onFocus: _ctx.showFullScreenHeader,
                    onBlur: _ctx.hideFullScreenHeader,
                    onClick: _ctx.openPrintInternetModal,
                    onKeydown: _withKeys(_withModifiers(_ctx.openPrintInternetModal, ["prevent"]), ["space","enter"]),
                    styled: "is-accent",
                    icon: "printer",
                    type: "button",
                    text: _ctx.$t('parts.print'),
                    disabled: _ctx.downloadingFlag,
                    class: "information-header-nav-print-guide display-header-on-focus",
                    id: "open-internet-printing-modal"
                  }, null, 8, ["onFocus", "onBlur", "onClick", "onKeydown", "text", "disabled"]),
                  (_ctx.downloadingFlag)
                    ? (_openBlock(), _createBlock(_component_IconLoading, {
                        key: 0,
                        class: "download-icon-loading"
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.stateModule.fullScreen)
              ? (_openBlock(), _createBlock(_component_ButtonIcon, {
                  key: 4,
                  onFocus: _ctx.showFullScreenHeader,
                  onBlur: _ctx.hideFullScreenHeader,
                  onClick: _ctx.exitFullScreen,
                  onKeydown: _withKeys(_withModifiers(_ctx.exitFullScreen, ["prevent"]), ["space","enter"]),
                  icon: "xmark-circle",
                  styled: "is-none",
                  class: "display-header-on-focus",
                  id: "fullscreen-xmark",
                  "aria-label": _ctx.$t('informationHeader.fullScreenAriaLabel')
                }, null, 8, ["onFocus", "onBlur", "onClick", "onKeydown", "aria-label"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.state.showPrintGuide)
          ? (_openBlock(), _createBlock(_component_ModalWindow, {
              key: 0,
              hasClose: false,
              heading: _ctx.$t(`printModal.${_ctx.state.printModalType}ModalTitle`)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PrintingModal, {
                  item: _ctx.item,
                  onClose: _ctx.closeModal,
                  onPrint: _ctx.showPdf,
                  onDownload: _ctx.download,
                  type: _ctx.state.printModalType
                }, null, 8, ["item", "onClose", "onPrint", "onDownload", "type"])
              ]),
              _: 1
            }, 8, ["heading"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}